<section class="ao-block" *ngIf="items && items && items.length && show">
  <header class="ao-header">
    <div class="row">
      <div class="col-sm-6">
        <h2 class="ao-header-title text-overflow">{{ title }}</h2>
      </div>
      <div class="col-sm-6 text-right total-records">
        <span *scText="fields.totalRecordsFound.label"></span>
        <strong>{{ totalNumberOfRecordsAvailable }}</strong>
      </div>
    </div>
  </header>

  <div class="table-responsive">
    <table class="table table-hover ao-table row-h-60 table-subrow">
      <thead>
        <tr>
          <th></th>
          <th *ngFor="let column of columns">{{ column }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of items; let i = index">
          <tr
            [ngClass]="{
              'table-row-odd': i % 2 === 0
            }"
          >
            <td class="collapse-button-cell">
              <button
                (click)="item.isCollapsed = !item.isCollapsed"
                class="btn btn-white btn-icon btn-collapse mr-1"
              >
                <i
                  class="icon-plus"
                  [ngClass]="{
                    'icon-plus': !item.isCollapsed,
                    'icon-minus': item.isCollapsed
                  }"
                ></i>
              </button>
            </td>
            <td>{{ item.refN }}</td>
            <td>{{ item.beneficiary }}</td>
            <td>{{ item.amount | abCurrency }}</td>
            <td>{{ item.approveeId }}</td>
            <td>{{ item.approvedDate | date: 'MM/dd/yyyy hh:mm a' }}</td>
          </tr>
          <tr
            class="subrow"
            [ngClass]="{ 'table-row-odd': i % 2 === 0 }"
            [ngbCollapse]="!item.isCollapsed"
          >
            <td colspan="8">
              <div class="row pl-3">
                <div
                  class="pl-2 pr-2 table-multiple-line"
                  *ngIf="item.preApproveeId && item.preApproveeId.length"
                >
                  <label *scText="fields.preapproveeID.label"></label>
                  <p>{{ item.preApproveeId }}</p>
                </div>
                <div
                  class="pl-2 pr-2 table-multiple-line"
                  *ngIf="item.preApproveeDate"
                >
                  <label *scText="fields.preapprovedate.label"></label>
                  <p>{{ item.preApproveeDate | date: 'MM/dd/yyyy hh:mm a' }}</p>
                </div>
                <div
                  class="pl-2 pr-2 table-multiple-line"
                  *ngIf="item.createId && item.createId.length"
                >
                  <label *scText="fields.createID.label"></label>
                  <p>{{ item.createId }}</p>
                </div>
                <div
                  class="pl-2 pr-2 table-multiple-line"
                  *ngIf="item.createDate"
                >
                  <label *scText="fields.createDate.label"></label>
                  <p>{{ item.createDate | date: 'MM/dd/yyyy hh:mm a' }}</p>
                </div>
                <div
                  class="pl-2 pr-2 table-multiple-line"
                  *ngIf="item.modifyId && item.modifyId.length"
                >
                  <label *scText="fields.modifyID.label"></label>
                  <p>{{ item.modifyId }}</p>
                </div>
                <div
                  class="pl-2 pr-2 table-multiple-line"
                  *ngIf="item.modifyDate"
                >
                  <label *scText="fields.modifyDate.label"></label>
                  <p>{{ item.modifyDate | date: 'MM/dd/yyyy hh:mm a' }}</p>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <div *ngIf="isLoading" class="loader-bar"></div>
  </div>
  <div
    *ngIf="hasMore"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="500"
    [fromRoot]="true"
    (scrolled)="onScroll()"
  ></div>
</section>
